// @flow
import * as IPPApi from "./IPPApi";

export default IPPApi;
